import React from 'react'

class Footerbottom extends React.Component {
  render() {
    return (
      <section id="footerbottom">
        <h6>
          &copy;2026 Webdesign &amp; Web Hosting Infrastructure on AWS by&nbsp;
          <a
            href="https://www.sandstorm.nl"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.sandstorm.nl
          </a>
          &nbsp;| Credits to HTML5UP |&nbsp;
          <a href="sitemap.xml">Hello Google &amp; friends!</a>
        </h6>
      </section>
    )
  }
}

export default Footerbottom
